export default __webpack_public_path__ + "8b083907d74e7f2b9a298e5f324cc751.mp4";